export const DASHBOARD = '/dashboard';
export const CHATS = '/chats';
export const CHANNELS = '/channels';
export const CONFIGURATION = '/configuration';
export const ONBOARDING = '/onboarding';
export const CLIENT_CONFIGURATION = '/client-configuration';
export const SPECIALTIES = '/specialties';
export const REMINDERS = '/reminders';
export const TRAINING = '/training';
export const NOTIFICATIONS = '/notifications';
export const ACCOUNT = '/account';
export const USERS = '/users';
export const LOGIN = '/login';
export const PRIVACY = '/privacy';
export const PRIVACY_POLICY = '/privacy-policies';
export const PATIENT_REMINDERS = '/patient-reminders';
export const SIGNUP = '/signup';
export const MESSAGES = '/messages';
export const TEMPLATES = '/templates';
export const ORGANIZATIONS = '/organizations';
export const RECOVER_PASSWORD = '/recover-password';
export const TEMPLATES_WAPI = '/templates-reminders';
